import dayjs, {Dayjs} from 'dayjs';

/**
 * Appends track info to the given FormData object of Sponsor commercial.
 *
 * Logic:
 * - Always append the selected track's ID (mediaTrackId).
 * - If the track was created AFTER the stepper was loaded,
 *   then it is considered a "processed_file".
 * - Otherwise, it is considered an "exist_track".
 *
 * @param formData        The FormData object to append values into.
 * @param selectedTrack   The selected track (must have id and optionally created_at).
 * @param stepperLoadedOn The timestamp when the stepper was loaded (dayjs object).
 * @returns               Updated FormData with mediaTrackId and track_from fields.
 */
export function sponsorCommercialAppendTrackInfo(
  formData: FormData,
  selectedTrack: {id?: number; created_at?: string} | null,
  stepperLoadedOn: Dayjs | null,
) {
  // If no track is selected, return the original formData
  if (!selectedTrack?.id) return formData;

  // Always append mediaTrackId
  formData.append('mediaTrackId', selectedTrack.id.toString());

  // Determine whether this is a new processed file
  // Condition: track created_at is after the stepper load time
  const isProcessedFile =
    selectedTrack.created_at &&
    stepperLoadedOn?.isBefore(dayjs(selectedTrack.created_at));

  // Append track_from based on the condition
  formData.append(
    'track_from',
    isProcessedFile ? 'processed_file' : 'exist_track',
  );

  return formData;
}
